// extracted by mini-css-extract-plugin
module.exports = {"drawerWrapper":"styles_drawerWrapper__31gxD","title":"styles_title__27kIY"};